import { Menu, Zap } from "lucide-react";
import UserMenu from "./UserMenu";

export const Navbar = ({ brand, user, onOpenDrawer }) => {
  return (
    <header className="topbar h-16 px-4 sm:px-8 flex items-center justify-between">
      <button
        type="button"
        onClick={onOpenDrawer}
        aria-label="Open menu"
        data-testid="drawer-open"
        className="lg:hidden text-slate-300 hover:text-white p-2 -ml-2 transition-colors"
      >
        <Menu size={22} />
      </button>
      <div className="lg:hidden flex items-center gap-2 flex-1 min-w-0 ml-1" data-testid="mobile-brand">
        {brand.logo_url ? (
          <img src={brand.logo_url} alt="logo" className="w-7 h-7 rounded-lg object-cover bg-white" />
        ) : (
          <div
            className="w-7 h-7 rounded-lg flex items-center justify-center text-black"
            style={{ background: brand.accent_color }}
          >
            <Zap size={14} strokeWidth={2.5} />
          </div>
        )}
        <span className="font-bold text-sm truncate">{brand.company_name}</span>
      </div>
      <UserMenu user={user} brand={brand} />
    </header>
  );
};

export default Navbar;
